import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./disclaimerCard.css";
import getIzProvider, { ProviderKey } from "../../models/providers/IzProviders";
import { DisclaimerStateModal } from "./DisclaimerStateModal";
import { Capacitor } from "@capacitor/core";
import { Dialog } from "@capacitor/dialog";
import { Browser } from "@capacitor/browser";

interface DisclaimerCardProps {
  provider: ProviderKey;
  screening?: boolean;
}

export default function DisclaimerCard({ provider, screening }: DisclaimerCardProps) {
  const { t } = useTranslation();
  const izProvider = getIzProvider(provider, t);
  const [disclaimerModal, setDisclaimerModal] = useState(false);
  const mic = "/assets/images/icons_mic.png";
  const isWeb = Capacitor.getPlatform() === "web";

  const getCardTitleText = () => {
    if (screening) {
      return t("screening.disclaimer_text");
    }
    return t("disclaimer.status", { iisAbbrev: izProvider.iisAbbrev });
  };

  const showDisclaimerModal = async () => {
    if (isWeb) {
      setDisclaimerModal(true);
    } else {
      const { value } = await Dialog.confirm({
        title: t("immunizations.disclaimer_title"),
        message: t(`immunizations.disclaimer_body_${izProvider.jurisdictionAbbrev.toLowerCase()}`),
        okButtonTitle: t("faq.faqs"),
        cancelButtonTitle: t("generic.cancel"),
      });
      if (value) {
        await Browser.open({ url: "https://dockethealth.com/faqs" });
      }
    }
  };

  return (
    <>
      <div
        className="flex flex-col sm:h-[5em] md:h-[7em] disclaimer-card mobile-card cursor-pointer"
        onClick={showDisclaimerModal}
      >
        <div className="disclaimer-badge-bg"></div>
        <div className="disclaimer-badge text-xs ml-1 font-semibold text-white">
          {t("immunizations.disclaimer_title")}
        </div>

        <div className="flex gap-1 ml-12 md:py-3 max-md:py-2 h-full">
          <div className="flex flex-col my-auto">
            <div
              role="paragraph"
              className="text-dark text-xs font-bold"
              data-testid="disclaimer-card-title"
            >
              {getCardTitleText()}
            </div>
            <button
              className="docket-button btn w-fit max-md:h-[30px] mt-[8px] max-md:hidden"
              onClick={showDisclaimerModal}
            >
              {t("disclaimer.learn_more")}
            </button>
            <p className="md:hidden text-sm text-gray-400">{t("disclaimer.mobile_learn_more")}</p>
          </div>

          <div className="my-auto md:mr-4 ml-auto max-md:mr-1">
            <img className="disclaimer-card-mic-img" src={mic} alt="Microphone" />
          </div>
        </div>
      </div>
      {disclaimerModal && (
        <DisclaimerStateModal
          closeModal={() => setDisclaimerModal(false)}
          stateCode={izProvider.jurisdictionAbbrev.toLowerCase()}
          screening={screening}
        />
      )}
    </>
  );
}
